import React from "react";
import AdminShell from "../components/AdminShell.jsx";

export default function AdminUsuariosIndex() {
  return (
    <AdminShell>
      <h3 className="mb-3">Usuarios</h3>
      <p>Listado de usuarios (placeholder).</p>
    </AdminShell>
  );
}
